import { React, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Lottie from 'lottie-react-web';

import SalesList from './SalesList';

import LoadingAnimation from '../../../Animation/LoadingAnimation.json';

const SalesHistory = (props) => {
  const { today, data, isOver, isSalesLoading, setIsSalesLoading } = props;

  const history = useHistory();

  useEffect(() => {
    setTimeout(() => {
      setIsSalesLoading(false);
    }, 1000)
  }, [data])

  // Sales List 클릭시 //
  function onClickSalesList(data) {
    if (data.memberId === undefined) {
      alert('이미 탈퇴한 회원입니다.');
      return;
    }

    history.push('/member/valid/detail/' + data.memberId);
  }

  return (
    <TopLevelWrapper isOver={isOver}>
      <InfoBox isOver={isOver}>
        <Title isOver={isOver}>{today.clone().format('YYYY년 MM월 총 매출 내역')}</Title>
        {
          isSalesLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie options={{ animationData: LoadingAnimation }} />
              </LottieWrapper>
            </AnimationBox>
            :
            <SalesList data={data} isOver={isOver} onClickSalesList={onClickSalesList} />
        }
      </InfoBox>
    </TopLevelWrapper>
  )
}

export default SalesHistory;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.isOver ? `max(692px, 90.10416666666667vw)` : `max(300px, 93.75vw)`};

  margin-top: ${props => props.isOver ? `38px` : `15px`};
  margin-bottom: ${props => props.isOver ? `96px` : `48px`};

  border-radius: 30px;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  background-color: #FFFFFF;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  width: 97.25%;
  height: ${props => props.isOver ? `528px` : `248px`};

  justify-conetent: center;
  align-items: flex-start;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  z-index: 5;
  
  width: 100%;
  height: 100%;

  // background-color: rgba(0, 0, 0, 0.2);
  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isOver ? `14px` : `10px`};

  color: #232323;

  margin: 28px 0 0 13px;
`;